import React from 'react';
import '../css/header.css';
import hamburger from '../images/baseline-menu-24px.svg';
import logo from '../images/d1_logo.png';

/**
 * Dairy One header component.
 * @author James Adams
 * @param {object} props
 * @returns {jsx}
 * @public
 */
function Header(props){
  let status = null;
  if(props.selectedMenu && props.selectedMenu.status){
    let capStatus = props.selectedMenu.status.charAt(0).toUpperCase() + props.selectedMenu.status.slice(1);
    status =(
      <React.Fragment>
        - {capStatus}
      </React.Fragment>);
  }

  return (
    <header>
      <div className="headerContainer">
        <img src={hamburger} className="hamburger" title="Open Menu" alt="Open Menu" onClick={props.clickHandler} />
        <img src={logo} className="logo" title="Dairy One Logo" alt="Dairy one Logo" />
        <span className="pageTitle">{props.title} {status}</span>
      </div>
      {props.children}
    </header>
  );
}

export default Header;
